module.exports = __webpack_public_path__ + "img/img-banking-char@3x.b9eb4a7d.png";